<template>
<div class="banner">
  <div class="container">
    <div class="banner__wrapper">
      <img src="@images/cardInBanner.png" alt="cards" class="banner__image" style="width: 600px" />
      <div class="banner__wrapper-content">
        <h2>{{ t('home.bottom-banner.title') }}</h2>
        <router-link :to="translations.i18nRoute({ name: 'market' })">
          {{ t('buttons.shop') }}
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
</script>

<style scoped lang="scss">

h2{
  color: #FFFFFF;
  font-size: 40px;
  font-weight: 800;
  max-width: 700px;
}

a{
  color: #FFFFFF;
  font-weight: 400;
  font-size: 30px;
  transition: 0.3s;

  &:hover{
    color: #DD6196;
  }
}


.banner {

  padding-top: 70px;
  padding-bottom: 70px;

  &__wrapper{
    position: relative;

    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);


    background-image: url("@images/bannerBottomBg.png");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border-radius: 15px;
    overflow: hidden;

    &-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 70px;

      padding: 65px 0 65px 42px;
    }
  }

  &__image{
    position: absolute;
    top: -32px;
    right: -39px;
  }
}

@media (max-width: 1100px) {
  .banner__image{
    bottom: -130px;
    right: -95px;
    top: unset;
    z-index: 1;
  }

  .banner__wrapper-content{
    gap: 140px;
    position: relative;
    z-index: 2;
    max-width: 490px;
  }
}

@media(max-width: 750px) {
  .banner__image{
    display: none;
  }

  .banner__wrapper-content{
    padding: 50px 20px;
  }

  .banner__wrapper{
    background-image: none;
    background-color: #AAABF3;
  }
}
</style>